import React from 'react'
import PropTypes from 'prop-types'
import { Div } from 'glamorous'

import Avatar from 'components/profile/Avatar'
import PersonInfo from 'components/profile/PersonInfo'
import LocationButton from 'components/common/LocationButton'
import Button from 'components/common/Button'

/** Head-Row of a profile, containing informations about a person. */
const ProfileHead = props => {
  const { firstName, age, distance, profilePic, onActionClick, isMe } = props

  return (
    <Div
      paddingLeft={15}
      paddingRight={15}
      display="flex"
      alignItems="center"
      height={80}
      width="100%"
      boxSizing="border-box"
    >
      <Avatar src={profilePic} />
      <Div flex={1} marginLeft={15} flexDirection="row" display="flex">
        <Div flex="1 1 auto" paddingRight={70}>
          <PersonInfo firstName={firstName} age={age} distance={distance} />
        </Div>
        <Div flex={0} position="absolute" right={12} top={12}>
          {isMe
            ? <LocationButton text="Change Location" onClick={onActionClick} />
            : <Button onClick={onActionClick}>Report</Button>
          }
        </Div>
      </Div>
    </Div>
  )
}

ProfileHead.propTypes = {
  /** Name of the person */
  firstName: PropTypes.string.isRequired,
  /** Age of the person */
  age: PropTypes.number.isRequired,
  /** Distance to the person */
  distance: PropTypes.string,
  /** URL to the main profile picture of the person */
  profilePic: PropTypes.string.isRequired,
  /** Action triggered when clicking the button in the header */
  onActionClick: PropTypes.func,
  /** Whether it's the currently logged-in user or another person */
  isMe: PropTypes.bool
}

ProfileHead.defaultProps = {
  onActionClick: () => {},
  isMe: false
}

export default ProfileHead



// WEBPACK FOOTER //
// ./src/components/profile/ProfileHead.js